import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../utils/Auth';
import { useOrganization } from '../../utils/OrganizationContext';
import LoadingSpinner from '../../components/LoadingSpinner';

export default function Sonar() {
  // ----- STATE INITIALIZATION -----
  const { currentUser, userObj, activeOrgId, loadingState } = useAuth();
  const { switchOrganization } = useOrganization();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const qrId = searchParams.get('qrid') || searchParams.get('qrId') || '';
  const fromApp = searchParams.get('app') === 'true';
  const qrURL = searchParams.get('qrurl');
  const qrOrg = searchParams.get('qrorg') || searchParams.get('orgId') || '';
  const qrType = searchParams.get('qrtype');
  // ----- END STATE INITIALIZATION -----
  // ----------------------------------------------

  useEffect(() => {
    // If fromApp is true, we must wait for auth to initialize
    if (loadingState.auth) {
      // Auth is still loading, don't make routing decisions yet
      return;
    }

    // If fromApp is true and auth has resolved, check if user is logged in
    if (fromApp && !loadingState.auth && !currentUser) {
      const loginParams = new URLSearchParams();
      loginParams.set('mode', 'login');
      loginParams.set('r', 'sonar');
      if (qrId) loginParams.set('qrid', qrId);
      if (qrOrg) loginParams.set('orgId', qrOrg);
      navigate(`/auth?${loginParams.toString()}`, { replace: true });
      return;
    }

    if (qrId) {
      if (currentUser) {
        // If it hits here there is a logged in user
        if (userObj) {
          // Check if user has access to qrOrg but is viewing different org
          if (qrOrg && userObj?.org_ids?.includes(qrOrg) && activeOrgId !== qrOrg) {
            // Switch to the org and redirect to QR details
            switchOrganization(qrOrg);
            navigate(`/collection/${qrId}/details`, { replace: true });
            return;
          } else if (activeOrgId === qrOrg) {
            // If it hits here the logged in user owns the QR
            navigate(`/collection/${qrId}/details`, { replace: true });
            return;
          } else {
            window.location.replace(`${process.env.REACT_APP_LQR_AI_ORIGIN}/${qrId}?sonar=false`);
            return;
          };
        };
      } else {
        window.location.replace(`${process.env.REACT_APP_LQR_AI_ORIGIN}/${qrId}?sonar=false`);
        return;
      };
    } else {
      navigate("/notfound");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser, userObj, activeOrgId, qrId, qrType, qrURL, qrOrg, fromApp, loadingState.auth]);

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
        <LoadingSpinner />
      </div>
    </>
  );
}
